import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';

export const PageLoading: React.FC = () => {
  return (
    <>
      <Grid
        container
        sx={{
          alignContent: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size="80px" sx={{ color: themeColors.scarletRed }} />
      </Grid>
    </>
  );
};
